import graphqlInstance from "../../config/graphqlConfig";
import { PROJECT_CATCH_ERROR_LIST } from "@platformx/utilities";
import { RolePermissionQueries } from "../../graphQL/queries/rolePermissionQueries";

const userRolePermissionApi = {
  getSiteModulePermissionList: async <T>(site: any, input?: T): Promise<any> => {
    try {
      const { loading, errors, data } = await graphqlInstance.query({
        query: RolePermissionQueries.SITE_MODULE_PERMISSION_LIST,
        variables: input,
        fetchPolicy: "no-cache",
        context: {
          // Without this opt-in the Apollo link overwrites the explicit sitename with
          // getSelectedSite(), silently returning the CURRENT site's module permissions.
          useProvidedSiteNameHeader: true,
          headers: {
            sitename: site,
          },
        },
      });
      return { loading, errors, data };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getSiteModulePermissionList`, err);
      throw err;
    }
  },
};
export default userRolePermissionApi;
